export enum EcoSessionDataLayerEvent {
    EnrollmentSuccess = "ecoSessionEnrollmentSuccess",
}
